import { CallToActionOneData } from '@/data';
import Link from '@/components/link';
import React from 'react';
import { useTranslation } from 'react-i18next';

const CtaOne = () => {
  const { title, button } = CallToActionOneData;
  const { t } = useTranslation();
  return (
    <section className="call_to_action">
      <div className="container">
        <div className="row">
          <div className="col-md-9 col-sm-8 col-xs-12">
            <h1>{t(title)}</h1>
          </div>
          <div className="col-md-3 col-sm-4 col-xs-12 text-end cta_responsive_left">
            <Link href={button.url} className="btn-gray">
              {t(button.label)}
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CtaOne;
